var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pl-aside-page"},[_c('div',{staticClass:"pl-aside-page-content"},[_vm._t("main")],2),_c('aside',{staticClass:"pl-aside-page-aside",attrs:{"id":"page-aside"}},[_vm._t("aside")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }